import { render, staticRenderFns } from "./ItemListFast.vue?vue&type=template&id=560466a1&scoped=true"
import script from "./ItemListFast.vue?vue&type=script&lang=js"
export * from "./ItemListFast.vue?vue&type=script&lang=js"
import style0 from "./ItemListFast.vue?vue&type=style&index=0&id=560466a1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "560466a1",
  null
  
)

export default component.exports